<template>
  <svg class="icon-play" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 4L23.1417 14.285C24.4364 15.0618 24.4364 16.9382 23.1417 17.715L6 28V4Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'HighlightsPlayIcon',
})
</script>

<style scoped lang="scss">
.icon-play {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
